module.exports = __webpack_public_path__ + "img/romania.b3b85cfb.svg";